import { render, staticRenderFns } from "./scrollTopBtn.vue?vue&type=template&id=0d719724&scoped=true"
import script from "./scrollTopBtn.vue?vue&type=script&lang=js"
export * from "./scrollTopBtn.vue?vue&type=script&lang=js"
import style0 from "./scrollTopBtn.vue?vue&type=style&index=0&id=0d719724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d719724",
  null
  
)

export default component.exports